/* eslint-disable react/prop-types */
import React from 'react';

import Toggle from '@atlaskit/toggle';

import { FEATURE_FLAG, IS_CLOUD } from '@qality/common-config';
import { StorageOfUniqueServices } from '@qality/common-service';

import {
  JiraAdminSettingsSectionLabels,
  JiraAdminSettingsSectionLabelsSubtitle,
  JiraAdminSettingsSectionTitle,
  JiraAdminSettingsSectionToggle,
} from './JiraAdminSettings.styled';
import { SentrySettings } from './SentrySettings';

type Props = {
  pluginEnableChanged: () => void;
  qalityVisibilityChanged: () => void;
  isPluginForNewProjectsEnabled: boolean;
  isQalityForNewProjectsEnabled: boolean;
};

export const JiraAdminSettingsView: React.FC<Props> = ({
  pluginEnableChanged,
  qalityVisibilityChanged,
  isPluginForNewProjectsEnabled,
  isQalityForNewProjectsEnabled,
}: Props) => {
  const uniqueMessages = StorageOfUniqueServices.get('uniqueMessages');
  return (
    <>
      <JiraAdminSettingsSectionTitle>
        {uniqueMessages['page.settings.admin.settings.section.title']}
      </JiraAdminSettingsSectionTitle>
      <JiraAdminSettingsSectionToggle id='isPluginForNewProjectsEnabled'>
        <Toggle
          onChange={pluginEnableChanged}
          isChecked={isPluginForNewProjectsEnabled}
          size='large'
        />
      </JiraAdminSettingsSectionToggle>
      <JiraAdminSettingsSectionLabels>
        <h3>{uniqueMessages['page.settings.admin.plugin.enable.label']}</h3>
        <JiraAdminSettingsSectionLabelsSubtitle>
          {uniqueMessages['page.settings.admin.plugin.section.subtitle']}
        </JiraAdminSettingsSectionLabelsSubtitle>
      </JiraAdminSettingsSectionLabels>
      <JiraAdminSettingsSectionToggle id='isQalityInNewProjectsVisible'>
        <Toggle
          onChange={qalityVisibilityChanged}
          isChecked={isQalityForNewProjectsEnabled}
          size='large'
        />
      </JiraAdminSettingsSectionToggle>
      <JiraAdminSettingsSectionLabels>
        <h3>{uniqueMessages['page.settings.admin.enable.label']}</h3>
        <JiraAdminSettingsSectionLabelsSubtitle>
          {uniqueMessages['page.settings.admin.section.subtitle']}
        </JiraAdminSettingsSectionLabelsSubtitle>
      </JiraAdminSettingsSectionLabels>

      {FEATURE_FLAG.isPremium && IS_CLOUD && <SentrySettings />}
    </>
  );
};
